import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-error"
}
const _hoisted_2 = { class: "w-full text-right mt-6" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Pending Barang")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: `Pending Pengiriman Barang`,
    visible: _ctx.dialogPending,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogPending = $event)),
    class: "dialog-voucher",
    modal: true,
    dismissableMask: true,
    onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideDialog()))
  }, {
    default: _withCtx(() => [
      _createVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitPendingManifest(!_ctx.v$.$invalid)), ["prevent"]))
      }, [
        _createVNode(_component_Textarea, {
          modelValue: _ctx.v$.description.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.description.$model = $event)),
          rows: "5",
          placeholder: "Tulis Alasan Anda",
          class: "w-full textarea-grey rounded-lg input-primary"
        }, null, 8, ["modelValue"]),
        ((_ctx.v$.description.$invalid && _ctx.submitted) || _ctx.v$.description.$pending.$response)
          ? (_openBlock(), _createBlock("small", _hoisted_1, _toDisplayString(_ctx.v$.description.required.$message), 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "btn-primary text-black mr-3 px-10 py-1",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "btn-secondary text-black px-10 py-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideDialog()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["visible"]))
}